export default __webpack_public_path__ + "assets/img-video-preview-ca265e2b.png";